import React, { useState } from 'react'
import s from './BlogTeaser.module.css'
import Image from "next/legacy/image"
import Link from 'next/link'
import { urlFor } from '@lib/sanity'
import { useTranslations } from 'next-intl'
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react'
import { Keyboard, Mousewheel } from 'swiper/modules'


export interface IListForm {
  image: any
  title: string
  url: string
}

export interface BlogTeaserProps {
  title?: string
  teaserUrl?: any
  teaserText?: any
  className?: string
  list?: Array<IListForm>
}

const BlogTeaser: React.FC<BlogTeaserProps> = ((props) => {
  let {
    list,
    className,
    title,
    teaserUrl,
    teaserText
  } = props

  const t = useTranslations('Global')
  const [swiper, setSwiper] = useState(useSwiper())

  return (
    <div className={`${s.root} mb-10 mt-10`}>
      <div>
        <div className=''>
          <div className={'h-full w-full relative'}>
            <div className={s.innerWrapper}>
              <div className={'mx-6 w-10/12 md:mx-16 pb-6'}>
                <h3 className={`${s.title}`}>{title}</h3>
              </div>
              {/*<div>*/}
              {/*    <div className={s.teaserText + ' hidden lg:block mb-8 text-sm font-medium text-black uppercase ml-6 lg:ml-4'}><span*/}
              {/*      className={s.blackDot}></span>{teaserText}</div>*/}
              {/*</div>*/}
              <div>
                <div>
                  {list && list?.length > 1 && <Swiper
                    onSlideChange={(_s: unknown) => {
                    }}
                    cssMode={true}
                    breakpoints={{
                      // when window width is >= 320px
                      0: {
                        slidesPerView: 1.2,
                      },
                      800: {
                        slidesPerView: 2.2,
                      },
                      // when window width is >= 800px
                      1280: {
                        slidesPerView: Math.min(list?.length, 3),
                      }
                    }}
                    navigation={false}
                    pagination={false}
                    mousewheel={true}
                    keyboard={true}
                    loop={false}
                    scrollbar={{
                      draggable: false
                    }}
                    onSwiper={(s: any) => {
                      setSwiper(s)
                    }}
                    modules={[Mousewheel, Keyboard]}
                    className={s.mySwiper}

                  >
                    {list && list.map((item, index) => {
                      const imageUrl = urlFor(item.image).url()
                      return <SwiperSlide key={item.title + index} className={s.swiperSlide}><Link href={item.url} target="_blank">
                          <div className={s.hoverWrapper + ' cursor-pointer'}>
                            <h1 className={s.mobileIndex + ' lg:hidden md:px-10 pb-2'}>{(index < 9 ? '0' : '') + '' + (index + 1)}</h1>
                            {item.image && imageUrl &&
                              <div
                                className={s.image + ' block h-full block overflow-hidden relative rounded-cornerS'}>
                                <Image className={'w-full h-full'} priority={false} loading="lazy" alt={'Blog teaser image' + index} src={imageUrl} layout='fill'
                                       objectFit='cover' />
                              </div>
                            }
                            <p
                              className={`${s.teaserElementtext} text-neutral900 font-normal text-paragraph01 md:px-space2`}>
                              {item.title}
                            </p>
                            <div className={s.link + ' text-neutral900 text-paragraph03 font-medium my-4 md:px-space2'}>
                              <div className={'inline-block border-b border-black border-solid'}>{t('more')}<span
                                className={s.linkHelper}></span></div>
                            </div>
                          </div>
                      </Link>
                      </SwiperSlide>
                    })}
                  </Swiper>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
})

export default BlogTeaser
